import gql from "graphql-tag";

export default gql`
  mutation downloadFile($id: ID!) {
    downloadFile(id: $id)
  }
`;
